import * as link from '@byted/ecom-mobile-lib/lib/core/link';
import urlQuery from 'libs/query';
import { PAGE_ORIGIN } from 'config/host';
import qs from 'qs';
import env from './env';
import bridge from 'libs/bridge';
import { urlPassOn } from 'config/event';

type keyProps = string | number;
let lock = false;
interface ILinkConfigExt extends link.ILinkConfig {
    replace?: boolean;
    control?: boolean;
    blackStatusBar?: boolean;
    closeAndOpen?: boolean;
    withSuffix?: boolean;
}

export const isSchema = (url: string) => {
    return link.isToutiaoLink(url) || link.isAwemeLink(url) || link.isSuperLink(url);
};

/* eslint-disable complexity */
export default function openLink(
    url: string,
    config?: ILinkConfigExt,
    options?: Record<keyProps, any>
) {
    if (lock) {
        return;
    }
    // schema直接跳转
    if (isSchema(url)) return open(url, config);

    let openUrl = url;
    const aftersaleOpenLink = config && config.control;
    if (!/^https?:\/\//i.test(url)) {
        openUrl = PAGE_ORIGIN + url;
    }
    if (config && config.withSuffix !== false) {
        openUrl += `${openUrl.indexOf('?') !== -1 ? '&' : '?'}` + getSuffix(options, openUrl);
    }
    // hide_h5_title=0 显示开启h5 title为了向前兼容端上没有这个query时不展示前端title
    // 这部分需要拼接在h5链接上被encode，为抖音设置
    if (aftersaleOpenLink) {
        const urlParams = `&${qs.stringify({
            hide_h5_title: env.isInSuper ? 1 : 0,
            status_font_dark: 1,
            hide_nav_bar: 1,
            loading_bgcolor: 'ffffff',
            status_bar_color: 'ffffff'
        })}`;
        openUrl += urlParams;
    }
    let transLink = link.transLink(openUrl, config);

    if (aftersaleOpenLink) {
        const webviewParams = `&${qs.stringify({
            hide_back_button: 1,
            hide_back_close: 1,
            hide_progress_bar: 1,
            // 各个端的schema不统一，too south...
            bounce_disable: 1,
            disable_bounces: 1,
            disable_bounce: 1,
            hide_bar: env.isInSuper ? 0 : 1,
            force_wkwebview: 1
        })}`;
        transLink += webviewParams;
    }
    if (config && config.blackStatusBar) {
        transLink += getColorStatusBar('000000');
    }
    if (env.isInToutiao) {
        transLink += '&hide_search=1';
    }
    if (env.isInSuper) {
        transLink += '&need_safe_area=1';
    }
    // 如果是懂车帝环境，因为无法隐藏返回按钮，所以不隐藏头部了
    if (env.isInMobile) {
        transLink = link.transLink(openUrl, { ...(config || {}), hideBar: false });
    }
    if (config && config.closeAndOpen && bridge.supports('closeAndOpen')) {
        bridge
            .call(
                'closeAndOpen',
                {
                    schema: transLink
                },
                { timeout: 500 }
            )
            .then(
                () => {},
                () => {
                    open(transLink, config);
                }
            );
    } else {
        open(transLink, config);
    }

    lock = true;
    setTimeout(() => {
        lock = false;
    }, 100);
}
function getColorStatusBar(color = '000000') {
    if (env.isInToutiao || env.isInToutiaoLite || (env.isInVideo && env.isIOS))
        return '&hide_status_bar=1&status_bar_color=white';
    if (env.isInAweme || env.isInVideo || env.isInHotsoon) return '&status_bar_color=' + color;
    // if (env.isInSuper) return '&hide_bar=1&hide_status_bar=1';
    return '';
}
export function open(link: string, config?: ILinkConfigExt) {
    if (config && config.replace) {
        window.location.replace(link);
    } else {
        // 抖音通过jsb打开
        if (env.isInAweme) {
            return bridge
                .call('openSchema', { reactId: window.location.href, schema: link })
                .then((res: any) => {
                    // TODO: 此处会误判为安卓调用失败
                    if (res && res.ret === 'JSB_SUCCESS') return;
                    throw new Error('JSB_FAIL');
                })
                .catch(() => {
                    window.location.href = link;
                });
        }
        window.location.href = link;
    }
}

// 打开schema，对JSB调用错误不做兼容处理
export function openSchema(link: string, config?: ILinkConfigExt) {
    if (config && config.replace) {
        window.location.replace(link);
    } else {
        // 抖音通过jsb打开
        if (env.isInAweme) {
            bridge.call('openSchema', { reactId: window.location.href, schema: link });
        } else {
            window.location.href = link;
        }
    }
}

export function nativeHref(url: string, options?: Record<keyProps, any>) {
    let openUrl = url;
    if (!/^https?:\/\//i.test(url)) {
        openUrl = PAGE_ORIGIN + url;
    }

    openUrl += `${openUrl.indexOf('?') !== -1 ? '&' : '?'}` + getSuffix(options);
    window.location.href = openUrl;
}

/* eslint-disable no-undefined, no-param-reassign */
function getParam(data: any) {
    if (!data) {
        return '';
    }

    return Object.entries(data)
        .filter(([_key, value]) => value !== undefined)
        .reduce(
            (search, [key, value], i, arr) =>
                search + key + '=' + value + (i === arr.length - 1 ? '' : '&'),
            ''
        );
}

function getExistParamInPath(paramsPath: keyProps[], encode: boolean = false) {
    for (let index = 0, len = paramsPath.length; index < len; index++) {
        if (paramsPath[index] !== undefined)
            return encode ? encodeURIComponent(String(paramsPath[index])) : paramsPath[index];
    }
    return undefined;
}

function innerParamsHandler(url: string, options: any) {
    if (typeof options !== 'object') return url;
    if (!/http|https|sslocal/i.test(url)) url = PAGE_ORIGIN + url;
    if (/http[s]?/i.test(url) && url.indexOf('?') === -1) {
        url += '?';
    } else {
        url += '&';
    }
    let query = getSuffix(options);
    return url + query;
}

export function nativeReplace(url: string, options = {}) {
    if (!/^http|https|sslocal|snssdk/i.test(url)) url = PAGE_ORIGIN + url;

    const newUrl = innerParamsHandler(url, options);
    location.replace(newUrl);
}
export function getSuffix(options?: Record<keyProps, any>, baseUrl?: string) {
    const data = Object.create(null) as Record<keyProps, any>;
    if (typeof options !== 'object') {
        options = {};
    }

    data.origin_type = getExistParamInPath([options.origin_type, urlQuery.origin_type, 0]);
    data.origin_id = getExistParamInPath([options.origin_id, urlQuery.origin_id, 0]);
    data.new_source_type = getExistParamInPath([
        options.new_origin_type,
        options.area_type,
        urlQuery.new_source_type,
        (window as any).page_type,
        0
    ]);
    data.new_source_id = getExistParamInPath([
        options.new_source_id,
        options.area_id,
        (window as any).page_id,
        0
    ]);
    data.source_type = getExistParamInPath([
        options.source_type,
        options.area_type,
        urlQuery.source_type,
        (window as any).page_type,
        0
    ]);
    data.source_id = getExistParamInPath([
        options.source_id,
        options.area_id,
        urlQuery.source_id,
        (window as any).page_id,
        0
    ]);
    data.entrance_info = getExistParamInPath([options.entrance_info, urlQuery.entrance_info], true);
    data.come_from = getExistParamInPath([options.come_from, urlQuery.come_from], true);
    data.buyin_track = getExistParamInPath([urlQuery.buyin_track]);
    urlPassOn.forEach((param) => {
        data[param] = getExistParamInPath([options![param], urlQuery[param]]);
    });
    const baseParams = baseUrl ? qs.parse(baseUrl.split('?')[1] || '') : {};
    for (const key in baseParams) {
        if (baseParams.hasOwnProperty(key)) {
            delete data[key];
        }
    }
    return getParam(data);
}
/* eslint-enable no-undefined, no-param-reassign */
